import { Box, Grid, GridSize } from '@material-ui/core'
import { Button } from 'components/facets'
import { AddIcon } from 'components/facets/Icons'
import { useTranslation } from 'react-i18next'
import { PriceStategyTarget } from 'shared'
import { PricingStrategyBox } from '../PricingStrategyBox'
import { PricingStrategiesPresenterProps } from './PricingStrategiesPresenter'

export const AddStrategyBox = ({
  onCreate,
  target,
}: {
  onCreate: (target: PriceStategyTarget) => void
  target: PriceStategyTarget
}): JSX.Element => {
  const { t } = useTranslation()

  return (
    <Button
      variant="contained"
      onClick={() => onCreate(target)}
      startIcon={<AddIcon />}
      data-testid="add-new-pricing-strategy-btn"
      style={{ margin: 8 }}
    >
      {t('strategy.addNew')}
    </Button>
  )
}

export const PricingStrategiesEditor = ({
  pricingStrategies,
  competitors,
  onDelete,
  onCreate,
  onChange,
  onClone,
  onConvertTo,
  competitionDisabled,
  rowCount,
  bulkSettings,
  target,
}: PricingStrategiesPresenterProps & { rowCount: 1 | 2 | 3 | 4 }): JSX.Element => {
  const strategies = pricingStrategies.filter((strategy) => strategy.target === target)

  return (
    <Grid container>
      {strategies.map((pricingStrategy) => (
        <Grid
          xs={12}
          xl={4}
          sm={(12 / rowCount) as GridSize}
          item
          key={pricingStrategy._id}
          data-testid={`strategy-box-${pricingStrategy.name}`}
        >
          <Box>
            <PricingStrategyBox
              competitors={competitors}
              pricingStrategy={pricingStrategy}
              onDelete={
                competitionDisabled && pricingStrategy.base.kind === 'articleData'
                  ? undefined
                  : onDelete
              }
              onChange={
                competitionDisabled && pricingStrategy.base.kind === 'articleData'
                  ? undefined
                  : onChange
              }
              competitionDisabled={competitionDisabled}
              onClone={
                competitionDisabled && pricingStrategy.base.kind === 'articleData'
                  ? undefined
                  : onClone
              }
              onConvertTo={onConvertTo}
              bulkSettings={bulkSettings}
            />
          </Box>
        </Grid>
      ))}
      <Grid xs={12} sm={(12 / rowCount) as GridSize} key={'new'} item>
        <AddStrategyBox target={target} onCreate={onCreate} />
      </Grid>
    </Grid>
  )
}
